import { FaqSection } from "../components/FaqSection";
import { CTABlock } from "../components/CTABlock";

export function FaqPage() {
	return (
		<>
			<FaqSection as="h1" />
			<CTABlock />
		</>
	);
}
